<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div [config]="preloaderService.getLoadingConfig(loaderKey)" [suiIsLoading]="loaderKey" class="preloader-wrapper">
    <form #editForm="ngForm" (ngSubmit)="submitForm()" class="dialog-form dialog-max-height-xxl" name="moveForm">
        <div class="siklu-mat-dialog-title" matDialogTitle>
            <h4>{{ 'entity.move.title' | translate }}</h4>
            <button matDialogClose windeClose>
                <sui-svg-icon icon="cross" />
            </button>
        </div>
        <div class="siklu-mat-dialog-body no-scroll" matDialogContent>
            <winde-alert-error></winde-alert-error>
            <winde-validation-alert
                [(showAlert)]="showFormValidationAlert"
                [messageObservable]="alertMessageSubject.asObservable()"
            ></winde-validation-alert>
            @if (!showConfirmation && projectMoveDto) {
                <div>
                    <div class="select-company">
                        <span
                            [innerHTML]="'entity.move.question' | translate: { name: projectMoveDto.name | gtthTextEscape }"
                            class="form-label ellipsis-span"
                        ></span>
                        <mat-form-field class="w-100" name="companyControl">
                            <mat-select [formControl]="companyControl">
                                @for (company of $companies | async; track company) {
                                    <mat-option [value]="company">
                                        {{ company.name }}
                                    </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                    @if (selectedCustomer) {
                        <div class="form-group">
                            <span class="form-label">Move to folder</span>
                            <div class="folders-tree custom-scroll-bar">
                                <winde-folders-tree></winde-folders-tree>
                            </div>
                        </div>
                    }
                </div>
            }
            @if (showConfirmation) {
                <div>
                    <span
                        [innerHTML]="
                            'entity.move.confirmationMessage'
                                | translate: { projectName: this.projectMoveDto.name, customerName: selectedCustomer.name }
                        "
                    ></span>
                </div>
            }
        </div>
        <div class="siklu-mat-dialog-footer" matDialogActions>
            <button matDialogClose windeTransparent>
                <sui-svg-icon icon="cross" />
                {{ 'entity.action.cancel' | translate }}
            </button>
            @if (!showConfirmation) {
                <button type="submit" windeGreen>
                    <sui-svg-icon icon="cross" />
                    {{ 'entity.action.move' | translate }}
                </button>
            }
            @if (showConfirmation) {
                <button (click)="submitForm()" windeGreen>
                    <sui-svg-icon icon="cross" />
                    {{ 'entity.action.confirm' | translate }}
                </button>
            }
        </div>
    </form>
</div>
